import {useQuery} from '@tanstack/react-query'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const config = getConfig()

/**
 * Fetches approaching discounts for a basket via the OCAPI proxy.
 * @param {string} basketId - The basket ID
 * @param {object} options
 * @param {string} options.productSignature - Cache key segment that changes when basket items change
 */
export const useApproachingDiscounts = (basketId, {productSignature} = {}) => {
    const {site} = useMultiSite()
    const siteId = config?.app?.commerceAPI?.parameters?.siteId

    return useQuery({
        queryKey: ['approachingDiscounts', basketId, productSignature],
        queryFn: async () => {
            const token = localStorage.getItem('access_token_' + site.id)
            const response = await fetch(
                `/mobify/proxy/ocapi/s/${siteId}/dw/shop/v20_8/baskets/${basketId}/approaching_discounts`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            )

            if (!response.ok) {
                throw new Error('Unable to fetch approaching discounts')
            }

            const data = await response.json()
            return data?.approaching_discounts ?? []
        },
        enabled: !!basketId
    })
}
